import { Component, OnInit } from '@angular/core';
import { OKTA_LOGIN_URL } from '@core/consts/okta-login-url.const';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  ngOnInit(): void {
    window.location.replace(OKTA_LOGIN_URL);
  }
}
